:root ._ff-f-family{font-family:var(--f-family);}
:root ._dsp-inline{display:inline;}
:root ._bxs-border-box{box-sizing:border-box;}
:root ._ww-break-word{word-wrap:break-word;}
:root ._ws-pre-wrap{white-space:pre-wrap;}
:root ._mt-0px{margin-top:0px;}
:root ._mr-0px{margin-right:0px;}
:root ._mb-0px{margin-bottom:0px;}
:root ._ml-0px{margin-left:0px;}
:root ._col-color{color:var(--color);}
:root ._fst-italic{font-style:italic;}
:root ._dsp-flex{display:flex;}
:root ._items-stretch{align-items:stretch;}
:root ._fb-auto{flex-basis:auto;}
:root ._pos-relative{position:relative;}
:root ._minH-0px{min-height:0px;}
:root ._minW-0px{min-width:0px;}
:root ._shrink-0{flex-shrink:0;}
:root ._fd-column{flex-direction:column;}
:root ._gap-t-space-lar3294{gap:var(--t-space-large);}
:root ._fd-row{flex-direction:row;}
:root ._gap-t-space-sma3456{gap:var(--t-space-small);}
:root ._justify-center{justify-content:center;}
:root ._items-center{align-items:center;}
:root ._self-center{align-self:center;}
:root ._gap-t-space-lar102228{gap:var(--t-space-larger);}
:root ._width-64px{width:64px;}
:root ._height-64px{height:64px;}
:root ._bg-background{background-color:var(--background);}
:root ._btlr-32px{border-top-left-radius:32px;}
:root ._btrr-32px{border-top-right-radius:32px;}
:root ._bbrr-32px{border-bottom-right-radius:32px;}
:root ._bblr-32px{border-bottom-left-radius:32px;}
:root ._shrink-1{flex-shrink:1;}
:root ._gap-t-space-med104641{gap:var(--t-space-medium);}
:root ._grow-1{flex-grow:1;}
:root ._width-16px{width:16px;}
:root ._height-16px{height:16px;}